/**
 * @name Resources
 * @description
 * Resources is a file to store constant variables
 * validation messages, encryption key, global variables
 **/


export const Resources: any = {
    "scheduleType": {
        "once": "En gång",
        "week": "Vecka",
        "month": "Månad",
    },
    "urls": {
        "fileUrl": "http://licens.cadelit.se/files/"
    },
    "dateInterval": [
        { key: 4, value: "Dag", prop: "day" }
        , { key: 5, value: "Vecka", prop: "week" }
        , { key: 2, value: "Månad", prop: "month" }
        , { key: 0, value: "År", prop: "year" }
    ],
    "jobStatus": [
        { key:1, text: "Tilldelad" }
        , { key:2, text:"Gjord" }
        , { key:3, text:"Flyttad" }
    ],
};